import { useEffect, useRef } from 'react';

export interface MenuAction {
  label: string;
  icon?: React.ReactNode;
  danger?: boolean;
  onClick: () => void;
}

interface ContextMenuProps {
  x: number;
  y: number;
  actions: MenuAction[];
  onClose: () => void;
}

export function ContextMenu({ x, y, actions, onClose }: ContextMenuProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  const adjustedY = Math.min(y, window.innerHeight - actions.length * 40 - 16);
  const adjustedX = Math.min(x, window.innerWidth - 220);

  return (
    <div
      ref={ref}
      className="fixed z-[100] surface-overlay py-2 min-w-52"
      style={{ top: adjustedY, left: adjustedX }}
    >
      {actions.map((action, i) => (
        <button
          key={i}
          onClick={() => { action.onClick(); onClose(); }}
          className={`w-full flex items-center gap-3 px-3.5 py-2 text-caption text-left transition-colors
            ${action.danger
              ? 'text-p1 hover:bg-p1/10'
              : 'text-text-primary hover:bg-accent/8'
            }`}
        >
          {action.icon}
          {action.label}
        </button>
      ))}
    </div>
  );
}
